





















import Vue from 'vue'

const formatCurrency = (amount: number, locale: string = 'pl-PL', currency: string = 'PLN') => {
	return amount.toLocaleString(locale, {
		style: 'currency',
		currency
	})
}
export default Vue.extend({
	name: 'BaseCurrency',
	model: {
		prop: 'modelValue',
		event: 'input'
	},
	props: {
		label: {
			type: String,
			required: false
		},
		placeholder: {
			type: String,
			required: false
		},
		isRequired: {
			type: Boolean,
			default: false
		},
		modelValue: {
			type: String
		},
		name: {
			type: String
		},
		locale: {
			type: String,
			default: 'pl-PL'
		},
		currency: {
			type: String,
			default: 'PLN'
		},
		id: {
			type: String,
			required: true,
			default: 'currency'
		}
	},
	mounted(): void {
		this.formatInput()
	},
	methods: {
		handleKeydown(e: KeyboardEvent): boolean | void {
			const allowedKeyCodes = [[48, 57], 188, 9, 37, 39, 8]
			// enter key
			if (e.keyCode === 13) {
				this.formatInput()
				this.$emit('keydownEnter')
				return
			}
			return this.isAllowed(e.keyCode, allowedKeyCodes) ? false : e.preventDefault()
		},
		handleInput(e: KeyboardEvent): void {
			const inputValue = (<HTMLInputElement>e.target).value
			this.$emit('input', inputValue)
		},
		handleFocus(): void {
			const inputValue = (this.$refs['currencyInput'] as HTMLInputElement).value
			this.$emit(
				'change',
				inputValue
					.split(/\s+/)
					.splice(0, inputValue.split(/\s+/).length - 1)
					.join('')
			)
		},
		formatInput(): void {
			const inputValue = (this.$refs['currencyInput'] as HTMLInputElement).value
			if (inputValue === '') return
			this.$emit('input', formatCurrency(parseFloat(inputValue.replace(',', '.')), this.locale, this.currency))
		},
		isAllowed(keyCode: number, allowedKeyCodes: (number | number[])[]): boolean {
			for (const value of allowedKeyCodes) {
				if (Array.isArray(value)) {
					const [start, end] = value
					if (keyCode >= start && keyCode <= end) return true
				} else {
					if (keyCode === value) return true
				}
			}
			return false
		}
	}
})
